<template>

    <div class="ui-toast-container">
        <transition-group :name="animation" :duration="animationDuration">

            <component v-for="toast in toasts" :key="toast.id"
                       :is="resolvedToastComponent"
                       :title="toast.title" :subtitle="toast.subtitle" :icon="toast.type.icon" :class="toast.type.classes"
                       @click="onToastClick(toast)"></component>

        </transition-group>
    </div>

</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-facing-decorator';
import type { Component as VueComponent } from 'vue';
import { clone } from 'lodash';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin } from '@wittignl/js-core';

import Toast from './Toast.vue';

@Component({
    name: 'ui-toast-container'
})
export default class ToastContainer extends Vue {

    @Prop({ type: [Object, Function, String] })
    toastComponent: VueComponent

    @Prop({ type: String, default: 'toast-list' })
    animation: string;

    @Prop({ type: [Number, String], default: null })
    animationDuration: number | string;

    get toasts() {

        const toasts = clone(this.$toast.toasts);
        toasts.reverse();

        return toasts;
    }

    get resolvedToastComponent(): VueComponent {

        return this.toastComponent || Toast;
    }

    onToastClick(toast) {

        this.$toast.close(toast);
    }
}

export type ToastContainerComp = InstanceType<typeof ToastContainer>
export type ToastContainerProps = ComponentProps<ToastContainerComp>
export const toastContainerCompMixin = createComponentMixin(ToastContainer)

</script>
<style src="../../../scss/component/toast/ToastContainer.scss" lang="scss"></style>